import type { ReactionId } from "../lib/emotionCatalog";
import { EMOTION_CATALOG, TOTAL_REACTIONS } from "../lib/emotionCatalog";

type Props = {
  seen: ReactionId[];
};

export function ReactionTracker({ seen }: Props) {
  return (
    <section className="panel reaction-dex">
      <header className="panel-head">
        <div>
          <p className="panel-label">Reaction Dex</p>
          <p className="panel-status">
            {seen.length} / {TOTAL_REACTIONS} unlocked
          </p>
        </div>
      </header>
      <div className="reaction-grid">
        {EMOTION_CATALOG.map((emotion) => {
          const unlocked = seen.includes(emotion.id);
          if (!unlocked) return (<></>);
          return (
            <div key={emotion.id} className={`reaction-card ${unlocked ? "unlocked" : "locked"}`}>
              <span className="reaction-title">{emotion.label}</span>
              <small>{emotion.description}</small>
              <span className="reaction-id">{emotion.id}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
